import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import * as THREE from 'three';
import React, { useState, useEffect } from "react";

/* global globalThis */



const _origFetch = (globalThis.fetch ?? window.fetch).bind(globalThis);

// petite file FIFO
function makeQueuedFetch(max = 6) {
  let running = 0;
  const q = [];

  const pump = () => {
    while (running < max && q.length) {
      running++;
      const job = q.shift();
      job();
    }
  };

  // accepte string ou Request
  return function queuedFetch(input, init) {
    return new Promise((resolve, reject) => {
      const run = () => {
        try {
          // si Request, on garde l’objet tel quel pour ne rien casser (headers, signal…)
          const p = _origFetch(input, init);
          p.then(resolve, reject).finally(() => { running--; pump(); });
        } catch (e) {
          running--;
          pump();
          reject(e);
        }
      };
      (running < max) ? run() : q.push(run);
    });
  };
}

// 1 seule instance, utilisée partout (MapLibre + Three)
const queuedFetch = makeQueuedFetch(6);

// IMPORTANT : alimente tous les consommateurs
globalThis.fetch = queuedFetch;     // MapLibre, ton code, etc.
window.self.fetch       = queuedFetch;     


const loadModel = async (url) =>{
    const loader = new GLTFLoader();
    const gltf = await loader.loadAsync(url);
    const model = gltf.scene;
    return model;
}
 console.log("window.maplibregl.config.MAX_PARALLEL_IMAGE_REQUESTS", window.maplibregl.config.MAX_PARALLEL_IMAGE_REQUESTS)
 window.maplibregl.config.MAX_PARALLEL_IMAGE_REQUESTS = 2;

 const TILE_MAX = 6; // concurrence tuiles
let tileRunning = 0;
const tileQueue = [];
const tilePump = () => { while (tileRunning < TILE_MAX && tileQueue.length) tileQueue.shift()(); };



/* global location */
 const isLite = new URL(document.location.href).searchParams.get('lite') === '1';

 console.log("window.maplibre isLite", isLite)

 export const word3D =  (modelOrigin, propHolder, container, hash=true)=>{
    const tim = setInterval(async ()=>{

        const maplibregl = window.maplibregl
        
        if(!window.maplibregl) return
        if(!window.maplibregl.Map) return
        clearInterval(tim)
        const sceneOrigin = new maplibregl.LngLat(modelOrigin[0], modelOrigin[1]);

        const emptyStyle = {
          "version": 8,
          "sources": {},
          "layers": [
            {
              "id": "background",
              "type": "background",
              "paint": { "background-color": "rgba(0,0,0,0)" }
            }
          ]
        };
        
        
        const map = new window.maplibregl.Map({
            container: container,
            zoom: 14,
            minZoom: 5,
            maxZoom: 14,
            hash: hash,
            center: sceneOrigin,
            pitch: 45,
            bearing: -45,
            canvasContextAttributes: { antialias: false, preserveDrawingBuffer: false },
            style: "./mapstyle.json",
            //style: "./maptiler.style.json",
            tileSize: 256,
            maxTileCacheSize: 96,
            fadeDuration: 0,
            /*transformRequest: (url, type) => {
              // On ne bride QUE les tuiles & sprites/glyphs, pas tes API
              const isTile = type === 'Tile' || /\.(pbf|png|jpg|jpeg|webp|avif|mvt)(\?|$)/i.test(url)
                           || /\/(tiles|raster|vector|glyphs|sprites)\b/i.test(url);
          
              if (!isTile) return { url };
          
              return new Promise((resolve) => {
                const task = () => {
                  resolve({ url }); // MapLibre va déclencher fetch() → passe par queuedFetch
                  // “relâche” dans le prochain tick pour lisser
                  setTimeout(() => { tileRunning--; tilePump(); }, 0);
                };
                tileQueue.push(task);
                if (tileRunning < TILE_MAX) { tileRunning++; tilePump(); }
              });
            }*/
          

        });
        if (maplibregl.setWorkerCount) maplibregl.setWorkerCount(1);
        if (map.setPrefersReducedMotion) map.setPrefersReducedMotion(true);
        //if (map.setTerrain) map.setTerrain(null);
        if (map.setPrefetchZoomDelta) map.setPrefetchZoomDelta(0);

        

        document.getElementById(container).map = map

        map.on("load", () => {
            document.getElementById("map-world").classList.add("ready");
        });

        let lastMove = 0;
        map.on("move", () => {
            const now = Date.now();
            if (now - lastMove < 200) return; // ignore si trop rapide
            lastMove = now;
            console.log("Map moved safely");
        });

        map.on("mousemove", (e)=>{
            
            propHolder.notification.onNotification("mousemove", {point: e.point, lngLat: e.lngLat, altitude: map.getZoom()}, {})
        })
        map.on("mousedown", (e)=>{
            propHolder.notification.onNotification("mousedown", {point: e.point, lngLat: e.lngLat, altitude: map.getZoom()}, {})

            //const {x:x, y:y, z: z} = map.getPosition3D(e.lngLat)
            //model1.position.set(x, y, z);
            //plane.position.set(x, y, z)

            //console.log("map.mousedown", e.lngLat, x, y, z)

            
        })
        map.on("mouseup", (e)=>{
            propHolder.notification.onNotification("mouseup", {point: e.point, lngLat: e.lngLat, altitude: map.getZoom()}, {})
        })

        map.on("zoom", (e)=>{
            propHolder.notification.onNotification("zoom", {zoom: map.getZoom(), container: container}, {})
        })
        map.on('error', function(e) {
            console.error('Map error:', e.error);
        });

        
          
        if(propHolder && propHolder.notification && propHolder.notification.addNotification){ 
            propHolder.notification.addNotification("MapDragPan", (type, msg, arg)=>{
                
                if(msg.enable){
                    map.dragPan.enable();
                }
                else{
                    map.dragPan.disable();
                }
            })

            propHolder.notification.addNotification("NavigateLngLat", (type, position, arg)=>{
                map.setCenter(position)
                
            })

            propHolder.notification.addNotification("Scene3DAsk", (type, msg, arg)=>{
                propHolder.notification.onNotification("Scene3D", {status: "ready", container: container}, map.scene)
            })
        }

        /*
        * Helper function used to get threejs-scene-coordinates from mercator coordinates.
        * This is just a quick and dirty solution - it won't work if points are far away from each other
        * because a meter near the north-pole covers more mercator-units
        * than a meter near the equator.
        */
        function calculateDistanceMercatorToMeters(from, to) {
            const mercatorPerMeter = from.meterInMercatorCoordinateUnits();
            // mercator x: 0=west, 1=east
            const dEast = to.x - from.x;
            const dEastMeter = dEast / mercatorPerMeter;
            // mercator y: 0=north, 1=south
            const dNorth = from.y - to.y;
            const dNorthMeter = dNorth / mercatorPerMeter;
            return {dEastMeter, dNorthMeter};
        }

        map.loadModel = loadModel

        map.getPosition3D = (lnglat)=>{
            const sceneOriginMercator = maplibregl.MercatorCoordinate.fromLngLat(sceneOrigin);
            const model1Mercator = maplibregl.MercatorCoordinate.fromLngLat(lnglat);
            const {dEastMeter: model1east, dNorthMeter: model1north} = calculateDistanceMercatorToMeters(sceneOriginMercator, model1Mercator);

            const sceneElevation = map.queryTerrainElevation(sceneOrigin) || 0;
            const model1Elevation = map.queryTerrainElevation(lnglat) || 0;
            const model1up = model1Elevation - sceneElevation;

            return  {x: model1east, y: model1up, z: model1north}
        }

        // Known locations. We'll infer the elevation of those locations once terrain is loaded.
        

        // Configuration of the custom layer for a 3D model, implementing `CustomLayerInterface`.
        const customLayer = {
            id: '3d-model',
            type: 'custom',
            renderingMode: '3d',

            onAdd(map, gl) {
                /**
                 * Setting up three.js scene.
                 * We're placing model1 and model2 in such a way that the whole scene fits over the terrain.
                 */

                this.camera = new THREE.PerspectiveCamera();
                this.scene = new THREE.Scene();
                this.scene.rotateX(Math.PI / 2);
                this.scene.scale.multiply(new THREE.Vector3(1, 1, -1));


                const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
                directionalLight.position.set(1, 0, 0).normalize();

                this.scene.add(directionalLight);

                const directionalLight2 = new THREE.DirectionalLight(0xffffff);
                directionalLight2.position.set(0, -1, 0).normalize();
                this.scene.add(directionalLight2);

                const directionalLight3 = new THREE.DirectionalLight(0xffffff);
                directionalLight3.position.set(0, 1, 0).normalize();
                this.scene.add(directionalLight3);
                
                map.scene = this.scene

                this.renderer = new THREE.WebGLRenderer({
                    canvas: map.getCanvas(),
                    context: gl,
                    antialias: false,
                    powerPreference: 'low-power'

                });

                this.renderer.autoClear = false;
                this.renderer.shadowMap.enabled = false;

                const scene = {camera: this.camera, renderer: this.renderer, scene: this.scene, sceneOrigin: sceneOrigin, map: map}

                propHolder.notification.onNotification("Scene3D", {status: "ready", container: container}, scene )

                map.scene = scene
                if(propHolder && propHolder.notification && propHolder.notification.addNotification){ 
                    
                }
                this.renderer.autoClear = false;
            },

            render(gl, args) {
                const offsetFromCenterElevation = map.queryTerrainElevation(sceneOrigin) || 0;
                const sceneOriginMercator = maplibregl.MercatorCoordinate.fromLngLat(sceneOrigin, offsetFromCenterElevation);

                const sceneTransform = {
                    translateX: sceneOriginMercator.x,
                    translateY: sceneOriginMercator.y,
                    translateZ: sceneOriginMercator.z,
                    scale: sceneOriginMercator.meterInMercatorCoordinateUnits()
                };

                const m = new THREE.Matrix4().fromArray(args.defaultProjectionData.mainMatrix);
                const l = new THREE.Matrix4()
                    .makeTranslation(sceneTransform.translateX, sceneTransform.translateY, sceneTransform.translateZ)
                    .scale(new THREE.Vector3(sceneTransform.scale, -sceneTransform.scale, sceneTransform.scale));

                this.camera.projectionMatrix = m.multiply(l);
                this.renderer.resetState();
                this.renderer.render(this.scene, this.camera);
                this.renderer.shadowMap.enabled = true;

                propHolder.notification.onNotification("Render", {}, {camera: this.camera, renderer: this.renderer, scene: this.scene, sceneOrigin: sceneOrigin, map: map})

               //map.triggerRepaint();
            }
        };
        

        //map.addLayer(customLayer);
        map.on('style.load', () => {
            
            map.addLayer(customLayer);

            

            
        });


        map.on('load', () => startLoop());
        map.on('remove', stopLoop);
        map.getCanvas().addEventListener('webglcontextlost', (e) => {
          e.preventDefault();
          stopLoop();
        }, { passive: false });
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'hidden') stopLoop();
          else startLoop();
        });


        let animRaf = 0;
        let running = false;

        // Cibles de frame pacing adaptatif : 60 → 45 → 30 FPS selon la charge
        const fpsTiers = [60, 45, 30];
        let fpsIdx = 0;
        let frameInterval = 1000 / fpsTiers[fpsIdx];
        let lastFrameTime = 0;
        let gpuOverBudgetCount = 0;

        // Heuristique simple : si la frame met trop longtemps souvent, on baisse la cible
        function adaptFps(now) {
          const delta = now - lastFrameTime;
          const overBudget = delta > frameInterval * 1.5; // 50% de marge
          gpuOverBudgetCount = overBudget ? (gpuOverBudgetCount + 1) : Math.max(0, gpuOverBudgetCount - 1);

          // 3 frames “lentes” d’affilée → on baisse un cran, 60→45→30
          if (gpuOverBudgetCount >= 3 && fpsIdx < fpsTiers.length - 1) {
            fpsIdx++;
            frameInterval = 1000 / fpsTiers[fpsIdx];
            gpuOverBudgetCount = 0;
            // console.log('FPS cap →', fpsTiers[fpsIdx]);
          }

          // 120 frames OK (~2s) → on remonte un cran (si possible)
          // (évite l’oscillation permanente)
          if (!overBudget && fpsIdx > 0 && performance.now() % 1200 < 20) {
            fpsIdx--;
            frameInterval = 1000 / fpsTiers[fpsIdx];
            // console.log('FPS cap ↑', fpsTiers[fpsIdx]);
          }
        }

        function loop(now) {
          if (!running) return;

          if (now - lastFrameTime >= frameInterval) {
            lastFrameTime = now;
            map.triggerRepaint(); // 1 frame MapLibre → appellera customLayer.render()
            adaptFps(now);
          }
          animRaf = requestAnimationFrame(loop);
        }

        function startLoop() {
          if (running) return;
          running = true;
          lastFrameTime = performance.now();
          animRaf = requestAnimationFrame(loop);
        }

        function stopLoop() {
          running = false;
          if (animRaf) cancelAnimationFrame(animRaf);
          animRaf = 0;
        }


        

    }, 100)
    

 }

 
  